import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBxCollapse = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M16.121 6.465 14 4.344V10h5.656l-2.121-2.121 3.172-3.172-1.414-1.414-3.172 3.172ZM4.707 3.293 3.293 4.707l3.172 3.172L4.344 10H10V4.344L7.879 6.465 4.707 3.293ZM19.656 14H14v5.656l2.121-2.121 3.172 3.172 1.414-1.414-3.172-3.172L19.656 14ZM6.465 16.121l-3.172 3.172 1.414 1.414 3.172-3.172L10 19.656V14H4.344l2.121 2.121Z"
	})
});
export default SvgBxCollapse;
